/* Vimeo is created only by the poster click. The rest of the page stays poster-only. */
if (!customElements.get('rewind-video')) customElements.define('rewind-video', class extends HTMLElement {
  connectedCallback() {
    if(this.bound)return;
    this.button=this.querySelector('button.rewind__play');if(!this.button)return;
    this.bound=true;this.abort=new AbortController();const options={signal:this.abort.signal};
    this.button.hidden=false;
    this.button.addEventListener('click',()=>this.start(),options);
    this.querySelector('[data-video-retry]').addEventListener('click',()=>this.start(),options);
    document.addEventListener('play',event=>{
      if(event.target instanceof HTMLMediaElement&&event.target.closest('rewind-cassette,rewind-vocal-player,rewind-drum-machine,rewind-midi-player,rewind-analog-player,rewind-melodic-player'))this.stop();
    },{...options,capture:true});
  }
  sdk(){
    if(window.Vimeo?.Player)return Promise.resolve(window.Vimeo);
    if(!window.REWIND_VIMEO_SDK)window.REWIND_VIMEO_SDK=new Promise((resolve,reject)=>{
      const script=document.createElement('script');script.src='https://player.vimeo.com/api/player.js';script.async=true;
      script.onload=()=>resolve(window.Vimeo);
      script.onerror=()=>{script.remove();window.REWIND_VIMEO_SDK=null;reject(new Error('Vimeo could not load.'))};
      document.head.append(script);
    });
    return window.REWIND_VIMEO_SDK;
  }
  claim(){
    window.REWIND_AUDIO?.claim(this);
    document.querySelectorAll('rewind-cassette audio,rewind-vocal-player audio,rewind-drum-machine audio,rewind-midi-player audio,rewind-analog-player audio,rewind-melodic-player audio').forEach(media=>{if(!media.paused)media.pause()});
  }
  async start(){
    const attempt=this.attempt=(this.attempt||0)+1;
    this.player?.destroy().catch(()=>{});this.iframe?.remove();this.player=null;
    this.querySelector('.rewind__video-error').hidden=true;
    const url=new URL(this.dataset.videoUrl,location.href);
    const match=url.hostname==='vimeo.com'&&url.pathname.match(/^\/(\d+)(?:\/([a-zA-Z0-9]+))?\/?$/);
    if(!match){this.fail('The Vimeo URL is not configured correctly.');return}
    this.claim();this.requested=true;
    const frame=this.iframe=document.createElement('iframe');
    const source=new URL('https://player.vimeo.com/video/'+match[1]);
    const hash=url.searchParams.get('h')||match[2];if(hash)source.searchParams.set('h',hash);
    for(const [key,value]of Object.entries({autoplay:'1',muted:'0',loop:'0',playsinline:'1',controls:'1',dnt:'1',autopause:'1'}))source.searchParams.set(key,value);
    frame.src=source.href;frame.title='REWIND collection film';frame.allow='autoplay; fullscreen; picture-in-picture; encrypted-media';frame.allowFullscreen=true;
    frame.setAttribute('referrerpolicy','strict-origin-when-cross-origin');
    this.querySelector('.rewind__preview').hidden=true;this.append(frame);frame.focus({preventScroll:true});
    try{
      const Vimeo=await this.sdk();if(attempt!==this.attempt)return;
      const player=this.player=new Vimeo.Player(frame);
      player.on('play',()=>{if(attempt!==this.attempt)return;this.dataset.playbackState='playing';this.claim();this.querySelector('.rewind__video-error').hidden=true});
      player.on('pause',()=>{this.dataset.playbackState='paused'});
      player.on('ended',()=>{this.dataset.playbackState='ended'});
      player.on('error',error=>this.fail(error.name==='PrivacyError'?'Vimeo is blocking this embed. Please open the film directly, or allow this store in Vimeo’s embed privacy settings.':'Vimeo could not play the film. Retry or open it directly.'));
      await player.ready();if(attempt!==this.attempt)return;
      if(!this.requested){await player.pause();return}
      // The iframe autoplay request carries the original user gesture. Keep Vimeo's
      // native play control available if a browser blocks sound until another tap.
      await player.setMuted(false);
      player.play().catch(()=>{});
    }catch(error){if(attempt===this.attempt)this.fail(error.name==='PrivacyError'?'Vimeo is blocking this embed. Please check the video’s embed privacy settings.':'Vimeo could not load. Check your connection, retry, or open the film directly.')}
  }
  fail(message){
    this.dataset.playbackState='error';this.requested=false;
    this.stop();if(this.iframe)this.iframe.hidden=true;
    this.querySelector('.rewind__preview').hidden=false;this.button.hidden=false;
    this.querySelector('[data-video-error-message]').textContent=message;this.querySelector('.rewind__video-error').hidden=false;
  }
  stop(){this.requested=false;this.player?.pause().catch(()=>{});if(this.iframe?.contentWindow)this.iframe.contentWindow.postMessage({method:'pause'},'https://player.vimeo.com')}
  disconnectedCallback(){this.attempt=(this.attempt||0)+1;this.player?.destroy().catch(()=>{});this.iframe?.remove();this.abort?.abort();this.bound=false}
});

// Development-only hero width controls; never shown on the storefront.
if (['127.0.0.1', 'localhost'].includes(location.hostname)) {
  const addPreviewControls = () => {
    document.querySelectorAll('.rewind').forEach(hero => {
      document.querySelectorAll('.rw-deck').forEach(deck => deck.classList.toggle('rw-deck--mobile-preview', hero.classList.contains('rewind--mobile-preview')));
      if (hero.querySelector('.rewind__preview-controls')) return;
      const controls = document.createElement('div');
      controls.className = 'rewind__preview-controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Local hero preview width');
      ['Desktop', 'Mobile'].forEach((label, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.setAttribute('aria-pressed', String(index === 0));
        button.addEventListener('click', () => {
          hero.classList.toggle('rewind--mobile-preview', index === 1);
          document.querySelectorAll('.rw-deck').forEach(deck => deck.classList.toggle('rw-deck--mobile-preview', index === 1));
          controls.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        });
        controls.append(button);
      });
      hero.prepend(controls);
    });
  };
  addPreviewControls();
  document.addEventListener('shopify:section:load', addPreviewControls);
  // Theme hot reload can replace the section without firing the editor event.
  let previewFramePending = false;
  new MutationObserver(() => {
    if (previewFramePending) return;
    previewFramePending = true;
    requestAnimationFrame(() => {
      previewFramePending = false;
      addPreviewControls();
    });
  }).observe(document.body, { childList: true, subtree: true });
}

/* Once-only REWIND entrances. Visible by default; no player internals are targeted. */
(function(){
  if(window.REWIND_REVEALS)return;
  window.REWIND_REVEALS=true;
  const motion=window.matchMedia?.('(prefers-reduced-motion: reduce)');
  // Late-loaded scripts must not hide content the visitor may already be reading.
  if(!motion||motion.matches||!('IntersectionObserver' in window)||document.readyState==='complete')return;
  const pending=new Set(),seen=new WeakSet();let observer;
  function show(element){element.classList.remove('rw-reveal-pending');pending.delete(element);observer?.unobserve(element)}
  function revealAll(){for(const element of pending)show(element);observer?.disconnect()}
  try{
    observer=new IntersectionObserver(entries=>{try{for(const entry of entries)if(entry.isIntersecting)show(entry.target)}catch{revealAll()}},{threshold:0,rootMargin:'0px 0px -20px 0px'});
    function register(element,delay=0){
      if(!element||seen.has(element)||element.closest('.rewind'))return;
      seen.add(element);
      // Existing viewport/anchor content stays immediate, including on mobile previews.
      if(element.getBoundingClientRect().top<window.innerHeight||element.contains(document.activeElement))return;
      observer.observe(element);
      element.style.setProperty('--rw-reveal-delay',delay+'ms');
      element.classList.add('rw-reveal','rw-reveal-pending');pending.add(element);
    }
    function scan(root){
      if(motion.matches)return;
      const intros='.rw-deck__header,.rw-vocals__header,.rw-drums__intro,.rw-midi__intro,.rw-analog__intro,.rw-melodic__intro,.rw-buy__intro';
      root.querySelectorAll(intros).forEach(header=>{let copy=0;for(const child of header.children)register(child,child.matches('h2,[class$="eyebrow"]')?0:Math.min(160,80+(copy++)*80))});
      const groups=[['rewind-cassette',100],['.rw-vocals__session',80],['.rw-vocal--hook',100],['.rw-vocal--phrase',180],['rewind-drum-machine',100],['rewind-midi-player',100],['rewind-analog-player',100],['rewind-melodic-player',100],['.rw-credits__inner',0],['.rw-buy__layout',100],['.rw-faq__inner>h2',0],['rewind-faq',80]];
      for(const [selector,delay]of groups)root.querySelectorAll(selector).forEach(element=>register(element,delay));
    }
    scan(document);
    document.addEventListener('shopify:section:load',event=>{try{scan(event.target)}catch{revealAll()}});
    document.addEventListener('focusin',event=>{for(const element of pending)if(element.contains(event.target))show(element)});
    motion.addEventListener('change',()=>{if(motion.matches)revealAll()});
    window.addEventListener('pageshow',event=>{if(event.persisted)revealAll()});
  }catch{revealAll()}
})();
